module.exports = {
	"title": "Pre-Travel Assessment",
	"label": "",
	"description": [
		"Use the following pre-travel assessment tool as a guide. Read through each assessment item and answer the question with a ‘yes’ or ‘no’. A ‘no’ response indicates elevated risk and appropriate control measures should be considered.",
		"Share the completed form with workers and clearly communicate risk factors and precautions to be taken."
	],
	"pdfLinks": [
		{
			"text": "C1. Travelling by Car",
			"fileName": "Community_Care_C1.pdf"
		},
		{
			"text": "C2. Safe Driving Practices",
			"fileName": "Community_Care_C2.pdf"
		},
		{
			"text": "C3. What to Do if Confronted by an Aggressive Driver",
			"fileName": "Community_Care_C3.pdf"
		},
		{
			"text": "C4. Parking Your Vehicle",
			"fileName": "Community_Care_C4.pdf"
		}
	],
	"subsections": [
		{
			"key": "travel",
			"subTitle": "Travel Route",
			"appendixSections": [
				"b1",
				"b2",
				"b3"
			],
			"checkedAppendixTips": {
				"b1": [
					[]
				],
				"b2": [
					[]
				],
				"b3": [
					[]
				]
			},
			"suggestedTips": [],
			"comment": "",
			"risks": [
				{
					"question": "Has the safest route to get to the client been identified?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Instruct worker to make sure the vehicle windows are closed and all vehicle doors are locked.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Establish clear guidelines for travelling in the community, including safety measures for travels by car, public transit, or walking.",
							"references": [
								"B1",
								"B2",
								"B3"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Has the crime rate for the location been determined through the local police department?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Contact local police services for information about crime trends and activities in the area.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is the client aware of the approximate time of arrival?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Establish and monitor home visiting schedule and check-in / out procedure.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						}
					]
				}
			]
		},
		{
			"key": "parking",
			"subTitle": "Parking Area",
			"appendixSections": [
				"c1",
				"c2",
				"c3",
				"c4",
				"c5"
			],
			"checkedAppendixTips": {
				"c1": [
					[],
					[],
					[]
				],
				"c2": [
					[]
				],
				"c3": [
					[]
				],
				"c4": [
					[]
				],
				"c5": [
					[]
				]
			},
			"suggestedTips": [],
			"comment": "",
			"risks": [
				{
					"question": "Has the closest and safest parking spot been located?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Ensure workers are aware of and follow safe driving practices and that vehicles are properly maintained.",
							"references": [
								"C1",
								"C2",
								"C3",
								"C4"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Do street lamps provide enough light for walking from the parked car or bus route to the entrance, and is there a light in the entrance to the building/home?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Avoid scheduling night visits if possible.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Advise worker to park under a streetlight if arriving in the late afternoon or at night.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Ensure workers are aware and follow safe driving practices for parking and returning to their vehicle.",
							"references": [
								"C2",
								"C4"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is the entrance visible from the road?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Ensure workers are aware and follow safe driving practices for parking and returning to their vehicle.",
							"references": [
								"C4",
								"C5"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				}
			]
		},
		{
			"key": "dwelling",
			"subTitle": " Inside/Outside Of Dwelling",
			"appendixSections": [
				"a1",
				"a2",
				"a3",
				"b1",
				"d1",
				"d2"
			],
			"checkedAppendixTips": {
				"a1": [
					[],
					[]
				],
				"a2": [
					[]
				],
				"a3": [
					[]
				],
				"b1": [
					[]
				],
				"d1": [
					[]
				],
				"d2": [
					[]
				]
			},
			"suggestedTips": [],
			"comment": "",
			"risks": [
				{
					"question": "Has the area been mapped out for potential perpetrator hiding spots (e.g. behind bushes or hedges)?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Inform workers of any known hazards.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Establish clear guidelines for travelling in the community.",
							"references": [
								"B1"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Are there any physical hazards (barriers, broken steps, free-roaming dogs, weapons) and, if so, is there a plan for controlling these hazards during the visit?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Ensure lighting is adequate. Request that the entry area light be on (if there is one) or provide worker with a flashlight if needed.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Ask client /family to secure firearms in a locked cupboard (separate from ammunition) prior to first contact with the worker.",
							"references": [
								"D2"
							],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Request client / family secure pets as necessary, prior to each visit.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Educate, train and provide instructions to workers on how to handle personal threats and dangerous weapons.",
							"references": [
								"D1",
								"D2"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "If there is a possibility of encountering hazards during the visit, have arrangements been made for a pre-visit and post-visit call to the office, a nurse, the supervisor or, if possible, a “buddy”?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Establish a routine check in / out procedure that allows for notification of identified hazards and implement a buddy system or personal safety response system for high-risk visits.",
							"references": [
								"B1"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Will other people be in the residence during the visit? If so, do you know how many, what their relationship to the client is, whether there any potential for violence, and who will open the door?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Ensure workers are trained in effective communications skills.",
							"references": [
								"A1"
							],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Educate, train and provide instructions to workers on how to terminate an interaction, and handle personal threats and dangerous weapons in the community.",
							"references": [
								"A2",
								"D1",
								"D2"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				}
			]
		},
		{
			"key": "egress",
			"subTitle": "Emergency Egress",
			"appendixSections": [
				"a2",
				"c5"
			],
			"checkedAppendixTips": {
				"a2": [
					[]
				],
				"c5": [
					[]
				]
			},
			"suggestedTips": [],
			"comment": "",
			"risks": [
				{
					"question": "Does the worker know where the nearest telephone is?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Encourage worker to carry a cell phone pre-programmed with emergency contact numbers.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Implement a risk-appropriate personal safety response system (PSRS).",
							"references": [
								"PSRS Toolkit"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Are there emergency phones or pull stations in the building, housing or parking complex?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Encourage worker to carry a cell phone pre-programmed with emergency contact numbers.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Does the path back to the vehicle allow for a quick and safe exit (e.g. unobstructed, illuminated)?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Request that client / family clear path, stairs and repair uneven surfaces before home visits.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Has the worker determined the safest route for returning to their vehicle?",
					"isRisk": false,
					"suggestedTips": [
						{
							"text": "Be observant! Look and listen.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Avoid slinging purse or bag over shoulder or around neck.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Carry your keys in your hand.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Walk around vehicle and check back seat before unlocking car.",
							"references": [],
							"isChecked": false,
							"isCustom": false
						},
						{
							"text": "Lock doors and keep windows up until underway.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						}
					]
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/store/initialState/preTravelState.json
// module id = 973
// module chunks = 0